<template>
  <div class="login-container">
    <div class="login-card">
      <h1 class="login-title">后台登录</h1>
      <div class="form-item">
        <label class="form-label">账号</label>
        <input
          v-model="loginForm.username"
          type="text"
          class="form-input"
          placeholder="请输入管理员账号"
          @keyup.enter="handleLogin"
        />
      </div>
      <div class="form-item">
        <label class="form-label">密码</label>
        <input
          v-model="loginForm.password"
          type="password"
          class="form-input"
          placeholder="请输入登录密码"
          @keyup.enter="handleLogin"
        />
      </div>
      <button class="login-btn" @click="handleLogin" :disabled="loading">
        {{ loading ? '登录中...' : '登录' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loading: false
    }
  },
  mounted() {
    // 已登录有token，直接跳后台
    if (localStorage.getItem('token')) {
        this.$router.push('/admin/imgManage')
      }
    },
    methods: {
      async handleLogin() {
        const username = this.loginForm.username.trim()
        const password = this.loginForm.password.trim()

        if (!username) {
          alert('请输入账号')
          return
        }
        if (!password) {
          alert('请输入密码')
          return
        }
      
        this.loading = true;
        try {
          // 改成表单格式发送，后端 $_POST 才能接收到
          const params = new URLSearchParams()
          params.append('username', username)
          params.append('password', password)
        
          const res = await this.$request.post('action.php?act=login', params, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
        
          if (res.code === 200) {
            console.log(res)
            localStorage.setItem('token', res.token)
            alert('登录成功')
            this.$router.push('/admin/imgManage')
          } else {
            console.log(1111)
            alert(res.msg || '账号或密码错误')
          }
        } catch (err) {
          console.error('登录请求异常：', err)
        } finally {
          this.loading = false
        }
      }


  }
}
</script>

<style scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-card {
  width: 440px;
  background: #ffffff;
  padding: 42px 36px;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.07);
}
.login-title {
  text-align: center;
  font-size: 28px;
  color: #222;
  margin: 0 0 36px 0;
  font-weight: 600;
}
.form-item {
  margin-bottom: 22px;
}
.form-label {
  display: block;
  font-size: 15px;
  color: #444;
  margin-bottom: 8px;
}
.form-input {
  width: 100%;
  box-sizing: border-box;
  padding: 13px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
}
.form-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
}
.login-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 8px;
  background-color: #409eff;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
}
.login-btn:hover {
  background-color: #337ecc;
}
.login-btn:disabled {
  background-color: #8cb8f5;
  cursor: not-allowed;
}
</style>
